import React from 'react';
import type { ClientBookingSummary } from '../../../types/client';

interface ClientDetailBookingsProps {
  bookings: ClientBookingSummary[];
}

const statusConfig: Record<string, { label: string; color: string; bg: string }> = {
  pending: { label: 'Pending', color: 'text-yellow-700', bg: 'bg-yellow-50' },
  confirmed: { label: 'Confirmed', color: 'text-blue-700', bg: 'bg-blue-50' },
  completed: { label: 'Completed', color: 'text-green-700', bg: 'bg-green-50' },
  cancelled: { label: 'Cancelled', color: 'text-red-700', bg: 'bg-red-50' },
  no_show: { label: 'No Show', color: 'text-gray-700', bg: 'bg-gray-100' },
};

const ClientDetailBookings: React.FC<ClientDetailBookingsProps> = ({ bookings }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h2 className="text-sm font-semibold uppercase tracking-wide text-gray-500 mb-4">
        Recent Bookings
      </h2>

      {bookings.length === 0 ? (
        <p className="text-sm text-gray-500">No bookings yet</p>
      ) : (
        <div className="space-y-3">
          {bookings.map((booking) => {
            const status = statusConfig[booking.status] || statusConfig.pending;

            return (
              <div
                key={booking.id}
                className="flex items-center justify-between p-3 rounded-lg bg-gray-50 hover:bg-gray-100 transition-colors"
              >
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <p className="text-sm font-medium text-gray-900 truncate">
                      {booking.services.join(', ') || 'Service'}
                    </p>
                    <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${status.color} ${status.bg}`}>
                      {status.label}
                    </span>
                  </div>
                  <p className="text-xs text-gray-500">
                    {booking.date_formatted} at {booking.time_formatted}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ClientDetailBookings;
